export const methodEditorInjectKey = '@wuji_source/MethodEditor';
//# sourceMappingURL=injectKey.js.map
